module.exports = __webpack_public_path__ + "static/img/kb-card-img-02-02@w.eec1081.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/kb-card/kb-card-img-02-02@w.jpg
// module id = z11j
// module chunks = 0